import superset from "./superset.js";

export default function subset(values, other) {
  return superset(other, values);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-contour/node_modules/d3-array/src/subset.js
// module id = 4612
// module chunks = 0